/**
 * Registry placeholder for `showPreferenceProposalWidget` in the web chat feed. It renders nothing:
 * on web, proposals are asked above the composer one at a time (`PendingPreferenceProposals`), so the
 * card stays out of the message it arrived in. It is still registered so the part counts as a known
 * widget rather than being reported as unknown. Mobile renders its own in-feed card.
 */
export function PreferenceProposalWidget() {
  return null;
}
